import Vue from 'vue'
import Router from 'vue-router'
import login from '../pages/Login'
import login_device from '../pages/LoginDevice'

Vue.use(Router)
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

const originalReplace = Router.prototype.replace;
Router.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch(err => err);
};
export const initRouterData = [
  {
    name : "login",
    path : "/login",
    component : login,
    // children:[]
  },
  {
    name : "login_device",
    path : "/login_device",
    component : login_device,
    // children:[]
  },
]

export default new Router({
  mode:'history',
  // mode: 'hash',
  base:'/pro_1/',//other nginx new pro_1
  routes: initRouterData,
  // 切换路由后滚动条置顶
  scrollBehavior() {
    return {
      x: 0,
      y: 0
    }
  }

})



// WEBPACK FOOTER //
// ./src/router/index.js